export default __webpack_public_path__ + "static/media/0.587eff27.jpg";